import MagentoClient from '../MagentoClient'

export default class RegisteredMagentoClient extends MagentoClient {
  constructor (domain, quoteId, currentUrl, token) {
    super(domain, quoteId, currentUrl)
    this.headers = {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  }

  setApiUrl () {
    const domain = this.domain
    this.apiUrl = `${domain}/rest/V1/carts/mine`
  }
}
